import { Link } from 'react-router-dom';

export default function StoryTeaser() {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #E8B96A 0%, #C9933A 50%, #7A2E2E 100%)' }}>
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/c8650eeb6e9ce3cc0258096ff3d491c4.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
        <p style={{ fontFamily: '"Dancing Script", cursive', color: '#fff', fontSize: '1.3rem' }} className="mb-3">Our Story</p>
        <h2 style={{ fontFamily: '"Playfair Display", serif', color: '#fff', lineHeight: 1.2 }} className="text-4xl md:text-5xl font-bold mb-6">
          From yoga studios to your closet —<br />
          <em>40 years of magic</em><br />
          and counting
        </h2>
        <p style={{ fontFamily: '"Lato", sans-serif', color: 'rgba(255,255,255,0.9)', lineHeight: 1.8 }} className="text-base md:text-lg mb-10">
          Earth Wisdom™ started in 1981 as one of the first retailers specializing in music for yoga, massage, and relaxation. We grew into something bigger — a full boutique brand built on two pillars: outrageously gorgeous goddess clothing and humor &amp; healing through apparel. Every piece we carry is chosen with love.
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-lg font-bold uppercase tracking-wide whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5 border-2 border-white"
          style={{ color: '#fff', fontFamily: '"Lato", sans-serif', letterSpacing: '0.1em', backgroundColor: 'transparent' }}
        >
          Meet Earth Wisdom <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}
